<template>
  <span
    class="pixel-text"
    :class="{ 'is-smooth': smooth }"
    :style="balancedStyle"
  >
    <canvas
      ref="canvas"
      :width="size.width"
      :height="size.height"
      :style="{ width: `${size.width}px` }"
      aria-hidden="true"
    />
    <span class="visually-hidden">{{ text }}</span>
  </span>
</template>

<script>
import { pixelTextSize, renderPixelText } from '@/pixel/text.js'

// Text in the style of the poster's "Säkerhets-SM 2027": white Pixel Mecha
// Bold with a rainbow border.
export default {
    props: {
        text: { type: String, required: true },
        // CSS pixels per font pixel; the poster uses 4.
        scale: { type: Number, default: 4 },
        // Squeeze the whole title rainbow into this text, for short words like "SSM".
        fit: { type: Boolean, default: false },
        // Smooth scaling, for when it's shown smaller than it is rendered.
        smooth: { type: Boolean, default: false },
        // Leave the extrusion out of the layout box, so centring centres the letters.
        balanced: { type: Boolean, default: false },
    },
    computed: {
        size () {
            return pixelTextSize(this.text, this.scale)
        },
        balancedStyle () {
            if (!this.balanced) return undefined
            return {
                marginRight: `-${this.size.depth}px`,
                marginBottom: `-${this.size.depth}px`,
                maxWidth: `calc(100% + ${this.size.depth}px)`,
            }
        },
    },
    watch: {
        text () {
            this.$nextTick(this.paint)
        },
        scale () {
            this.$nextTick(this.paint)
        },
        fit () {
            this.$nextTick(this.paint)
        },
    },
    mounted () {
        this.paint()
    },
    methods: {
        paint () {
            const ctx = this.$refs.canvas && this.$refs.canvas.getContext('2d')
            if (!ctx) return
            const image = renderPixelText(this.text, { scale: this.scale, fit: this.fit })
            ctx.putImageData(new ImageData(image.d, image.w, image.h), 0, 0)
        },
    },
}
</script>

<style scoped>
.pixel-text {
  display: inline-block;
  line-height: 0;
  max-width: 100%;
  vertical-align: top;
}

canvas {
  display: block;
  max-width: 100%;
  height: auto;
  image-rendering: pixelated;
}

.is-smooth canvas {
  image-rendering: auto;
}
</style>
